import React from 'react'
import { Box } from '@mui/material'
import { useTranslate } from 'react-admin'
import { BasePageLayoutProps } from './type'
import { ListActions } from '../components/list-actions'

const defaultListActions = {
  hasCreate: false,
  hasEdit: false,
  hasDelete: false,
  hasBackButton: false,
  hasExport: false,
  hasShow: false,
  resources: {
    create: '',
    edit: '',
    show: '',
    export: '',
    list: '',
  },
}

const BasePageLayout: React.FC<BasePageLayoutProps> = ({
  children,
  title,
  listActions = defaultListActions,
}) => {
  const translate = useTranslate()
  return (
    <Box>
      <ListActions title={translate(title || '')} {...listActions} />
      <Box sx={{ mt: 3 }}>{children}</Box>
    </Box>
  )
}

export default BasePageLayout
